import BrickTitle from "@/components/landing/BrickTitle";

const PORTRAIT_IMG =
  "https://images.pexels.com/photos/5493674/pexels-photo-5493674.jpeg?auto=compress&w=1200";

export default function About() {
  return (
    <section id="about" className="py-20 bg-[#1B2229] border-y border-[#3A4752]" data-testid="about-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-5">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-[#DCD3C9] shadow-md relative">
              <img
                src={PORTRAIT_IMG}
                alt="Will in a hard hat, leveling and marking a wall with a full tool belt"
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-6 text-white">
                <span className="font-bold text-lg leading-tight">Will &middot; Craftsman &amp; Builder</span>
                <span className="text-xs text-[#D8D2CA] mt-1">Committed to honest, durable neighborhood repairs</span>
              </div>
            </div>
          </div>

          <div className="md:col-span-7">
            <span className="text-xs font-bold uppercase tracking-widest text-[#D4691E]">Upstanding &amp; Committed</span>
            <h2 className="text-3xl sm:text-4xl font-bold mt-2 mb-6">
              <BrickTitle text="I Treat Your Home Exactly Like My Own" />
            </h2>

            <div className="space-y-4 text-sm text-[#544D45] leading-relaxed">
              <p>
                My name's Will — call me Will or William, doesn't bother me one bit. I take immense pride in running a
                straightforward, honest business. As a devoted family man &mdash; working every day to set an
                upstanding example for my son Evander and my two wonderful nieces Kaidynn and Rylie &mdash; my word
                and my craftsmanship are my greatest assets.
              </p>
              <p>
                When I step across your threshold, your property is treated with the highest standard of care. I use
                clean drop cloths, wear shoe covers, protect your furnishings, and do not leave until the repair is
                solid, clean, and thoroughly tested.
              </p>
              <p className="font-medium text-[#1E252B]">
                Whether it is a custom timber table, welding a gate hinge back to life, or servicing your AC during
                summer heat, you get my full dedication from start to finish.
              </p>
              <p className="font-bungee text-lg font-bold text-[#1E252B]">&mdash; Will</p>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-8 pt-6 border-t border-[#DCD3C9]">
              <div>
                <div className="font-bold text-base text-[#1E252B]">Honest Communication</div>
                <div className="text-xs text-[#736B63] mt-0.5">No sudden surprise invoices</div>
              </div>
              <div>
                <div className="font-bold text-base text-[#1E252B]">Full Clean-Up</div>
                <div className="text-xs text-[#736B63] mt-0.5">Left cleaner than we found it</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
